<template>
  <div class="pay-container">
    <common-header
      content="支付结果"
      fontColor="#000"
      backgrounds="#fff"
    ></common-header>
    <div class="pay-result">
      <img
        :src="pay_status === 'SUCCEED' ? payment : paymenterror"
        alt="支付icon"
      />
      <span>{{ pay_status === "SUCCEED" ? "支付成功" : "支付失败" }}</span>
      <div @click="returnClick" class="return">返回</div>
    </div>
    <common-report-explain class="export"></common-report-explain>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { paymentCallChecks, getProductList } from "../../api/index";
import payment from "img/payment.png";
import paymenterror from "img/paymenterror.png";
import CommonHeader from "../../components/commonHeader.vue";
import CommonReportExplain from "../../components/commonReportExplain";
import { onMounted, ref } from "vue";
export default {
  name: "PaymentResult.vue",
  components: { CommonHeader, CommonReportExplain },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      window.history.pushState({}, "title", "#");
    }
    // const payObj = ref({})
    // 支付状态
    const pay_status = ref("");
    const { biz_content } = route.query;
    const change_biz_content = JSON.parse(biz_content);
    const { trade_status } = change_biz_content;
    pay_status.value = trade_status;
    // payObj.value = {
    //   sign_type,
    //   sign,
    //   "notify_time": timestamp,
    //   "notify_type": "USP",
    //   "data": {
    //     trade_status,
    //     out_trade_no,
    //     trade_no,
    //     app_id,
    //     "gmt_create": timestamp,
    //     "receipt_amount": receipt_amount,
    //     "pay_amount": receipt_amount,
    //     "total_amount": receipt_amount,
    //     "subject": store.state.perm,
    //     "gmt_payment": timestamp,
    //   },
    //   "task_id": "dba45757-c710-4881-8052-bba9f208a406"
    // }
    /** 返回 */
    const returnClick = () => {
      router.push(`/home/${store.state.testCode}`);
    };
    // 获取商品列表
    const getProdList = async (batchCode) => {
      try {
        const { data } = await getProductList(batchCode);
        // 把商品列表对象保存到store中
        store.commit("saveProductObj", data[0]);
      } catch (error) {
        console.log(error);
      }
    };
    onMounted(async () => {
      const { sign_type, timestamp, sign, biz_content, app_id } = route.query;
      // 跳转到结果页面把数据给后端
      const {
        data: { projectCode, idNumber, batchCode },
      } = await paymentCallChecks(
        sign_type,
        timestamp,
        sign,
        biz_content,
        app_id
      );
      store.commit("saveCredentialsID", idNumber);
      store.commit("saveTestCode", projectCode);
      getProdList(batchCode);
    });
    return {
      payment,
      returnClick,
      paymenterror,
      pay_status,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
@import "scss/color.scss";
.pay-container {
  width: 100%;
  height: 100%;
  .pay-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 750px;
    height: 300px;
    background: #ffffff;
    padding: 60px 0;
    border-top: 1px solid #ddd;
    img {
      width: 108px;
      height: 108px;
    }
    span {
      font-size: 40px;
      margin-top: 30px;
    }
    .return {
      @include flex-center;
      width: 232px;
      color: var(--primary-color);
      font-size: 30px;
      height: 68px;
      border-radius: 45px;
      border: 2px solid var(--primary-color);
      margin-top: 50px;
    }
  }
  .export {
    height: 44%;
    padding: 0 4vw 10% 4vw;
  }
}
</style>
